export const userNavigationMapping = {};
